module.exports = __webpack_public_path__ + "img/ic-top-up-amount.57966798.svg";